module.exports = __webpack_public_path__ + "static/media/nike-eor-winner-3.4de2803b.jpg";